import { motion } from "motion/react";
import { Link } from "@tanstack/react-router";

/**
 * "How the House Works" homepage section.
 * Consolidated copy — chapter frequency lives only in the Release List section.
 */
export function SeasonalChapters() {
  return (
    <section id="how-the-house-works" className="relative py-10 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-3xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="eyebrow">Seasonal Chapters</p>
          <h2 className="mt-5 text-3xl text-parchment sm:text-4xl lg:text-5xl">
            How the <span className="italic text-gold/90">House Works</span>
          </h2>

          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-muted-foreground sm:mt-10 sm:text-xl">
            The House releases in seasonal chapters — small pre-order windows,
            opened only while the work is ready. Every bottle includes a
            companion vial.
          </p>

          <div className="ornament mt-10 hidden md:block">
            <span>✶</span>
          </div>

          <div className="mt-8 flex justify-center sm:mt-10">
            <Link
              to="/how-it-works"
              className="group inline-flex items-center justify-center gap-3 border border-gold bg-gold px-9 py-4 font-display text-xs uppercase tracking-[0.26em] text-ink transition-all duration-300 ease-out hover:bg-gold-soft hover:shadow-[0_0_20px_rgba(184,164,123,0.25)] active:scale-[0.97]"
            >
              How It Works
              <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
